export default function CTASection() {
  return (
    <section id="cta" className="relative py-16 md:py-24 bg-accent-500 overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-background-50/10 rounded-full -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-background-50/10 rounded-full translate-y-1/2 -translate-x-1/3"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 dark:text-foreground-950 mb-4">
          准备好探索成91了吗？
        </h2>
        <p className="text-background-50/90 dark:text-foreground-950/90 text-sm md:text-base mb-8 max-w-lg mx-auto">
          立即加入成91平台，开启您的全新体验之旅。千万用户的选择，期待您的加入！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button className="px-8 py-3 bg-background-50 text-foreground-950 rounded-lg font-medium text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg">
            立即开始
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <button className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 dark:text-foreground-950 rounded-lg font-medium text-sm hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20">
            查看使用指南
          </button>
        </div>
      </div>
    </section>
  );
}